import React from 'react';

export const ScrollToTop = () => {
  React.useLayoutEffect(() => {
    document.querySelector('body').scrollTo(0, 0);
  }, []);
  return null;
};
